import { useEffect } from 'react';

import { APP_TOAST_EVENT } from '@src/corelib/query';

import { ToastStack, useToastQueue } from './toastQueue';


/** App-level toast surface (#162): listens for `ao:app-toast` events raised by
 * the shared mutation onError (e.g. the subscription soft-wall 403) and renders
 * a transient toast. Mounted once in the /app shell. Pages keep their own
 * local toasts for inline feedback. */
function GlobalToaster() {
  const { toasts, push } = useToastQueue(3200);

  useEffect(() => {
    const handler = (event) => {
      const { message, variant = 'danger' } = event.detail || {};
      push(message, variant);
    };

    window.addEventListener(APP_TOAST_EVENT, handler);
    return () => window.removeEventListener(APP_TOAST_EVENT, handler);
  }, [push]);

  return <ToastStack zIndexClassName="z-[70]" toasts={toasts} />;
}

GlobalToaster.displayName = 'GlobalToaster';
export default GlobalToaster;
